if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        const params = new URLSearchParams(window.location.search);
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (params.get('_purchase_source') && params.get('_purchase_source_product_id')) {
          formData.append('properties[_purchase_source]', params.get('_purchase_source'));
          formData.append('properties[_purchase_source_product_id]', params.get('_purchase_source_product_id'));
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (response.status === 422) {
                const _this = this;
                fetch(`${routes.cart_url}.js`, fetchConfig('javascript'))
                  .then((response) => response.json())
                  .then((response) => {
                    publish(PUB_SUB_EVENTS.cartPromotionsRefresh, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
                    _this.error = false;
                    const quickAddModal = _this.closest('quick-add-modal');
                    if (quickAddModal) {
                      document.body.addEventListener('modalClosed', () => {
                        setTimeout(() => {
                          _this.cart.renderContents(response);
                        });
                      }, { once: true });
                      quickAddModal.hide(true);
                    } else {
                      _this.cart.renderContents(response);
                    }
                  });
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartPromotionsRefresh, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('model-product-form')) {
  customElements.define(
    'model-product-form',
    class ModelProductForm extends customElements.get('product-form') {
      constructor() {
        super();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        formData.append('sections', 'model-wishlist-product-card');
        formData.append('sections_url', window.location.pathname);

        // Check if cart ID exists in localStorage and include it
        const existingCartId = localStorage.getItem('cartId');
        console.log('Existing Cart ID:', existingCartId);
        if (existingCartId) {
          formData.append('cart_id', existingCartId);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(`${this.form.action}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.errors) {
              this.handleErrorMessage(response.errors);
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading__spinner').classList.add('hidden');
              return;
            }

            // Store cart ID in localStorage if available
            if (response.success && response.cartId && response.cart.checkoutUrl) {
              localStorage.setItem('cartId', response.cartId);
              localStorage.setItem('cartCheckoutUrl', response.cart.checkoutUrl);
              window.location.href = response.cart.checkoutUrl;
              return;
            }

            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
    }
  );
}
